<template>
  <div class="ui-content dashboard">
    <div class="institute-drop" v-if="students.length > 1 && isParent">
      <div class="past-test-dropdown">
        <v-select
          @change="updateSelectedStudent"
          :items="students"
          v-model="selectedStudent"
          hide-details
        ></v-select>
      </div>
    </div>
    <div class="cumulative-back-button">
      <v-btn depressed color="indigo" @click="goBack()" class="cumulative-btn">
        Back
      </v-btn>
    </div>
    <div class="page-user user cat-2">
      <v-tabs
        v-model="tab"
        background-color
        class="elevation-2 cust-tab"
        @change="updateBreadCrumbs"
      >
        <v-tabs-slider></v-tabs-slider>
        <v-tab :href="'#Chapter wise Standing'">Chapter wise Standing</v-tab>
        <v-tab v-if="!onlineUser" :href="'#Percentile Variation'">Percentile Variation</v-tab>
        <v-tabs-items :touchless="true" v-model="tab">
          <v-tab-item :value="'Chapter wise Standing'">
            <v-card class="mx-auto normal-card chart-scr-card px-2 py-2">
              <ChapterwisePerformance :studentId="studentId" />
            </v-card>
          </v-tab-item>
          <v-tab-item :value="'Percentile Variation'">
            <v-card class="mx-auto normal-card chart-scr-card">
              <PercentileVariation :studentId="studentId" />
            </v-card>
          </v-tab-item>
        </v-tabs-items>
      </v-tabs>
    </div>
  </div>
</template>

<script>
// import ChapterStanding from '@/components/student/CumulativeAnalysis/ChapterStanding.vue'
import ChapterwisePerformance from "@/components/student/ChapterwisePerformance.vue";
import PercentileVariation from "@/components/student/CumulativeAnalysis/PercentileVariation.vue";
import { mapMutations, mapState } from "vuex";
import constants from "@/utils/constants.js";

export default {
  name: "OnlineChapterStanding",
  components: {
    ChapterwisePerformance,
    PercentileVariation,
  },
  computed: {
    ...mapState("userStore", ["user"]),
  },

  mounted() {
    this.checkSessionData();
    this.onlineUser = this.user.institute === constants.ONLINE_INSTITUTE_ID ? true : false ;
  },
  data() {
    return {
      tab: null,
      students: [],
      selectedStudent: [],
      studentId: this.$route.params.student_id || null,
      isParent: false,
      onlineUser:false
    };
  },
  methods: {
    ...mapMutations("app", ["addBreadCrumbChilde"]),
    defaultData() {
      let routeName = this.$route.name;
      let crd = this.getCurrentRouteDetails(routeName);
      if (crd) {
        this.tab = crd.selectedTab ? crd.selectedTab : "Chapter wise Standing";
      }
      if (this.user.role_id == this.roleIds.PA) {
        this.initStudentData();
      } else {
        this.studentId = this.$route.params.student_id || this.user.id;
      }
    },
    goBack() {
      this.$router.go(-1);
    },
    showCumulativeButton() {
      let user = JSON.parse(sessionStorage.getItem("user"));
      return (
        user &&
        (user.role_id === constants.ROLES_ID.ID ||
          user.role_id === constants.ROLES_ID.CO ||
          user.role_id === constants.ROLES_ID.TR)
      );
    },
    checkSessionData() {
      let rp = this.$route; // route params
      let crd = this.getCurrentRouteDetails(rp.name);

      if (rp.params.resetPage || !crd.routeName) {
        let routeDetails = {
          routeName: rp.name,
          selectedTab: crd.selectedTab
            ? crd.selectedTab
            : "Chapter wise Standing",
        };
        this.setRouteDetails(routeDetails);
      }
      this.defaultData();
      this.updateBreadCrumbs();
    },
    updateSelectedStudent() {
      this.studentId = this.$route.params.student_id || this.selectedStudent.id;
    },
    initStudentData() {
      this.isParent = true;
      this.students = this.user.students.map((student) => {
        let studentObj = {
          text: student.name,
          value: {
            id: student.id,
            batchId: student.batch_id,
            type: student.type,
          },
        };
        return studentObj;
      });
      this.selectedStudent = this.students[0].value;
      this.studentId = this.$route.params.student_id || this.selectedStudent.id;
    },
    updateBreadCrumbs() {
      let breadCrumbs = [];
      breadCrumbs.push({
        text: this.tab,
        disabled: false,
      });
      this.addBreadCrumbChilde(breadCrumbs);
    },
  },
  watch: {
    tab(val, oldVal) {
      if (oldVal) {
        // only when tab is changed and not on page load
        let routeName = this.$route.name;
        this.setRouteDetails({ routeName, selectedTab: val });
      }
    },
  },
};
</script>

